<template>
    <mapa-google
    ref="GoogleMaps"
    :coordenadas="coordenadas"
    :coordenadas-entrada="coordenadas"
    :desactivar-mapa="true"
    :icono-central="`/img/icons/${icono}`"
    :dragable="false"
    :height="heightMapa"
    width="100%"
    @actualizar="actualizarCoordenadas"
    />
</template>
<script>
export default {
    props: {
        coordenadas: {
            type: Object,
            required: false,
            default: () => ({ lat: 0, lng: 0 })
        },
        heightMapa: {
            type: String,
            default: '150px'
        },
        buscar: {
            type: String,
            default: ''
        },
        icono: {
            type: String,
            default: 'leechero-point-map.svg'
        }
    },
    mounted(){
        this.$refs.GoogleMaps.dibujarMapa()
    },
    methods: {

        accionBuscar(){
            if (this.buscar){
                setTimeout(() => {
                    this.$refs.GoogleMaps.buscarDireccion(this.buscar)
                }, 500);
            }
        },
        actualizarCoordenadas({ lat: latitud, lng: longitud }){
            this.$emit('actualizar', { latitud, longitud })
        },
        setPosition(){
            this.$refs.GoogleMaps.setNewPostition()
        }
    }
}
</script>
